import { Component, OnInit, Input, Output, EventEmitter, ElementRef, ViewChild, ViewEncapsulation, NgZone } from '@angular/core';
import { FormBuilder, FormGroup, Validators, NgForm, FormArray, FormControl } from '@angular/forms';
import { AbstractControl } from '@angular/forms';
import { NotifierService } from 'angular-notifier';
import { ActivatedRoute, Router } from '@angular/router';
import { MatTooltipModule } from '@angular/material/tooltip';

import * as jwt_decode from "jwt-decode";
import { UserService } from '../../../app/services/user.service';
import { LoginService } from '../../../app/services/login.service';
import { TokenStorageService } from '../../../app/services/token-storage.service';
import { BootController } from '../../../boot-control';
import { environment } from '../../../environments/environment';
import { ChangePasswordDialogComponent}from '../i-forms/user/change-password-dialog/change-password-dialog.component'
//import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';

export class ConfirmPasswordValidation {
  static MatchPassword(AC: AbstractControl) {
    if(!AC.get('newPassword')||!AC.get('confirmPassword')) {
      return null;
    }

    let password = AC.get('newPassword').value; // to get value in input tag
    let confirmPassword = AC.get('confirmPassword').value; // to get value in input tag
    if(password != confirmPassword) {
      AC.get('confirmPassword').setErrors( {MatchPassword: true} )
    } else {
      AC.get('confirmPassword').setErrors( null )
      return null
    }
  }
}

// declare function loadingServiceHide(id);
 declare var $: any;
@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
 // encapsulation: ViewEncapsulation.None
})

export class ResetPasswordComponent implements OnInit {
  showInfo: boolean = false;
  public authDecoded: any;
  public userId: any;
  public loginId: any;
  hideOld: boolean = true;
  hideNew: boolean = true;
  hideConfirm: boolean = true;
  public changePasswordForm: FormGroup;
  @ViewChild('tooltip') tooltip;
  private user: any;
  roles: any[];
  public loggedInUserId: any;
  public reg = '(?!.* )(?=.{8,})(?=.*?[^\w\s])(?=.*?[#?!@$%^&*-])(?=.*?)(?=.*?[A-Z]).*?[a-z].*'

  
  public Password_Criteria = `1. Must be at least 8 characters long
  2. Must contain one Upper and one Lower case alphabetic characters
  3. Must contain one special character
  4. New password must not match any of the previous 12 passwords
  5. Must not be the same as User ID’s `

  // showDelay = new FormControl(0);
  // hideDelay = new FormControl(4000);
  
  private readonly notifier: NotifierService;
  public hideTooltip: boolean = false;
  public loggedInEmail: any;
  strength: string;
  showPasswordRules: boolean = false;
  showGoodPassword: boolean;
  isLoggedIn: boolean=false;
  public showHelpIcon:boolean  = false;


  constructor(
    private fb: FormBuilder,
    private userService: UserService,
    public notifierService: NotifierService,
    private router: Router,
    private login: LoginService,
    private ngZone: NgZone,
    private token: TokenStorageService,
    private route: ActivatedRoute,
		//public dialogRef: MatDialogRef<ChangePasswordDialogComponent>
  ) {
    
    //this.loginId = this.authDecoded.userPayload.loginId;
    this.route.queryParams
      .subscribe(params => {
        if(params.id == undefined || params.id == null){
          this.isLoggedIn = true;
        }
      });
    this.notifier = notifierService;
    
  }

  ngOnInit() {
    //loadingServiceHide('mfa-loader');
    this.route.queryParams
      .subscribe(params => {
        if(params.id == undefined || params.id == null){
          this.isLoggedIn = true;
        }
      });
    if(this.isLoggedIn==true){
      this.authDecoded = jwt_decode(localStorage.getItem('AuthorizationD'));
      this.userId = this.authDecoded.userPayload.userKey;
      this.loggedInUserId  = this.userId;

      if ((!this.loggedInUserId)) {
      this.login.logout().then(data => {
       this.clearSession();
        
        this.router.navigate(['/login']);
      },
      error => {
        
      });
      }
    }
  }

  noUserIDs(control: FormControl) {
    let value = control.value.match(/[\w-]+@([\w-]+\.)+[\w-]+/g)
    return !value ? null : {'sameAsUserId': true}
  }

 /* onFormSubmit(form:NgForm,data) {
    alert("onsubmit")
    this.notifier.hide("changePass");
    this.notifier.notify('info', 'Processing...','0');
    if (this.changePasswordForm.invalid) {
      // this.notifierService.notify('error', 'Please fill required field!');
    } else {
      let userData = {};
      userData['confirmPassword'] = form['newPassword'];
      userData['password'] = form['newPassword'];
      userData['changePasswordLinkKey']=this.userId;

      this.userService.changePassword(this.userId, userData,this.isLoggedIn).subscribe(data => {
        if(data.apierror!=undefined) {
          this.notifier.hide('0');
          if(typeof(data) == "string") {
            this.notifier.getConfig().behaviour.autoHide = false;
            setTimeout(() => {
            this.notifier.notify('error', `Failed! ${data}`,"changePass");
          }, 1000);
          }
          else 
          this.notifier.getConfig().behaviour.autoHide = false;
          setTimeout(() => {
          this.notifier.notify('error', data.apierror.message,"changePass");
        }, 1000);
          return 
        }

        if((JSON.parse(localStorage.getItem('loggedInUser')))) {
          localStorage.setItem('setPassword','false');
          if(localStorage.getItem("enableDashboard") == "true"){
            this.router.navigate(['/home/dashboard']);
          }else{
            if(localStorage.getItem("defaultView") == null){
            localStorage.setItem("defaultView","sender"); 
            }
            this.router.navigate(['/home/invoices']); } 
        } else {
          //this.router.navigate(['']);
        }
        //this.dialogRef.close();
        this.notifier.hide('0');
        this.notifier.getConfig().behaviour.autoHide = 5000;
        this.notifier.notify('success', 'Password Changed Successfully');
      }, error => {
        this.notifier.hide('0');
        this.notifier.getConfig().behaviour.autoHide = false;
        setTimeout(() => {
        this.notifier.notify('error', 'Failed! Please try again later!',"changePass");
      }, 1000);
      });
    }
  }
*/
  closeDialog(){
    this.clearSession();
    //this.router.navigate(['/login']);
		//this.dialogRef.close();
  }
  
  clearSession(){
		localStorage.removeItem('AuthorizationD');
				localStorage.removeItem('JSESSIONID');
				localStorage.removeItem('token');
				localStorage.removeItem('expires_at');
				localStorage.removeItem('selectedTile');
				localStorage.removeItem('widgets');
				localStorage.removeItem('loggedInUser');
				localStorage.removeItem('userId');
                localStorage.removeItem('setPassword');
		  this.token.signOut();     
				
	}

  getStrength(data) {
    
    if (data == 0 || data == 1)  {
      this.strength = 'weakest';
    }
    else if (data == 2){
      this.strength = 'medium';
    }
    else {
      this.strength = 'strong';
    }
    
  }

  updateRules() {
    if (this.changePasswordForm.controls.newPassword.valid) {
      this.showPasswordRules = false;
      this.showGoodPassword = true;
      setTimeout(() => {
        this.showGoodPassword = false;
        this.showPasswordRules = true;
      }, 5000);
    }
    else {
      this.showGoodPassword = false;
      this.showPasswordRules = true;
    }

  }

  ShowHelp() {
    if (!this.showHelpIcon) {
      this.showHelpIcon = true;
      this.login.setZendeskView(false);
    }
  }

  hasClass() {
		if(document.getElementById("myLauncher").classList.contains('help-icon') ){
			this.showHelpIcon = false
		}else if(document.getElementById("myLauncher").classList.contains('help-icon-click') ) {
			this.showHelpIcon = true;
		}
		return this.showHelpIcon;
	  }

}

